export default __webpack_public_path__ + "static/media/dashboardIcon.298571d1.svg";